var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4453_17633)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3276 21.5508V12.6849L24 8.25525V16.7817C24 16.9971 23.8925 17.1832 23.706 17.2909L16.3276 21.5508ZM7.09838 17.1443H0.907969C0.406547 17.1443 0 16.7378 0 16.2364C0 15.735 0.406547 15.3284 0.907969 15.3284H7.06608C8.13089 15.3284 8.13089 13.6279 7.06608 13.6279H3.36548C2.86406 13.6279 2.45747 13.2213 2.45747 12.7199C2.45747 12.2185 2.86406 11.8119 3.36548 11.8119H6.25983C7.32464 11.8119 7.32464 10.1114 6.25983 10.1114H0.908016C0.406594 10.1114 4.6875e-05 9.70486 4.6875e-05 9.20344C4.6875e-05 8.70202 0.406594 8.29547 0.908016 8.29547H7.12777L14.7307 12.685V21.5508L7.09838 17.1443ZM7.85105 6.87366L15.5291 11.3066L23.2072 6.87361L15.5438 2.44922H10.5158C10.0144 2.44922 9.60787 2.85577 9.60787 3.35719C9.60787 3.85861 10.0144 4.26516 10.5158 4.26516H11.5784C11.676 4.26516 11.7578 4.32792 11.7831 4.42219C11.8083 4.51645 11.7689 4.6117 11.6843 4.66055L7.85105 6.87366ZM7.41398 2.44922C7.91541 2.44922 8.32195 2.85577 8.32195 3.35719C8.32195 3.85861 7.91541 4.26516 7.41398 4.26516H1.89506C1.39364 4.26516 0.987047 3.85861 0.987047 3.35719C0.987047 2.85577 1.39359 2.44922 1.89506 2.44922H7.41398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4453_17633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingFilled);
export default __webpack_public_path__ + "static/media/shipping_filled.94723ceb64a3563ce396daa150bafb08.svg";
export { ForwardRef as ReactComponent };